import { render, staticRenderFns } from "./CompetitionListHomeLayout.vue?vue&type=template&id=00ca33ea&scoped=true"
import script from "./CompetitionListHomeLayout.vue?vue&type=script&lang=js"
export * from "./CompetitionListHomeLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ca33ea",
  null
  
)

export default component.exports